import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "./Header";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { ProductContext } from "../context/AppContext";
import axios from "axios";

const Entranceresult = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [examResults, setExamResults] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const [applicationStatus, setApplicationStatus] = useState("");
  const authtoken = localStorage.getItem("token");

  const {
    getRegistration,
    allClass = [],
    fetchMyRegistrationData,
    Automationdata,
  } = useContext(ProductContext);

  // ✅ Fetch Exam Result Data
  const fetchExamResultData = async () => {
    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/result/username`,
        {
          method: "GET",
          headers: {
            "x-auth": authtoken,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch exam data");
      const data = await response.json();
      setExamResults(data?.data || []);
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  // ✅ Fetch Dashboard API (for class info)
  const fetchDashboardAPI = async () => {
    try {
      const response = await axios.get(
        `https://api.mirai.healthcare/api/register/dashboard`,
        {
          headers: {
            "x-auth": authtoken,
            "Content-Type": "application/json",
          },
        }
      );
      setDashboardData(response?.data);
    } catch (err) {
      console.error("Dashboard API Error:", err);
      if (err.response?.status === 401) {
        navigate("/login");
      }
    }
  };

  useEffect(() => {
    fetchExamResultData();
    fetchDashboardAPI();
  }, []);

  // ✅ Helper functions
  const capitalizeFirstLetter = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "pass":
        return "green";
      case "fail":
        return "red";
      default:
        return "gray";
    }
  };

  const ClassdataNew = {
    class: Number(getRegistration?.data?.select_class),
  };

  const ClassLabel = allClass
    ?.filter((item) => item.value === ClassdataNew.class)
    .map((item) => item.label)[0];

  // ✅ Apply for Admission
  const handleApplyAdmission = async () => {
    const userId = getRegistration?.data?.id;
    if (!userId) {
      alert("User ID is missing!");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/register/application-status/${userId}`,
        {
          method: "PATCH",
          headers: {
            "x-auth": authtoken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ application_status: "applied" }),
        }
      );

      if (response.ok) {
        setApplicationStatus("applied");
        Swal.fire("Success", "Admission applied successfully!", "success");
      } else {
        Swal.fire("Error", "Failed to apply for admission!", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong!", "error");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Apply for Re-Test
  const handleApplyRETest = async () => {
    const userId = getRegistration?.data?.id;
    if (!userId) {
      alert("User ID is missing!");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/register/${userId}`,
        {
          method: "PATCH",
          headers: {
            "x-auth": authtoken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ exam_status: "reexam" }),
        }
      );

      if (response.ok) {
        Swal.fire("Success", "Re-Test applied successfully!", "success");
        // navigate("/index");
        await fetchDashboardAPI;
        await fetchExamResultData();
      } else {
        Swal.fire("Error", "Failed to apply for Re-Test", "error");
      }
    } catch (error) {
      console.error("Error applying for Re-Test:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content background-color_row">
        <Header />
        <div className="col-md-12 text-center mt-3 mb-3">
          <h3 className="page-title">Exam Result</h3>
        </div>

        {examResults && examResults?.length > 0 ? (
          <div className="row">
            {/* ✅ Conditional Buttons */}
            <div className="col-md-12 text-center mb-3">
              {getRegistration?.data?.exam_status === "fail" && (
                <button
                  className="btn btn-primary me-2"
                  onClick={handleApplyRETest}
                  disabled={loading}
                >
                  {loading ? "Applying..." : "Apply for Re-Test"}
                </button>
              )}

              {getRegistration?.data?.exam_status === "reexam" && (
                <p className="text-warning fw-bold">
                  Already applied for Re-Test
                </p>
              )}
              {getRegistration?.data?.exam_status === "interviewed" && (
                <p className="text-success fw-bold">
                  Already applied for Interview
                </p>
              )}
              {getRegistration?.data?.exam_status === "interview" && (
                <button
                  className="btn btn-primary"
                  onClick={() => navigate("/examinterview")}
                >
                  Apply for Interview
                </button>
              )}
            </div>
            <div className="row d-flex align-items-center background-color_row">
              {/* ✅ Exam Result Cards */}
              {examResults.map((exam, index) => (
                <div className="col-md-4 mb-4" key={index}>
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title card-title_RightSide">
                        {exam?.examdetails?.exam_name?.name}
                        {exam?.is_reexam && (
                          <span className="badge bg-danger">Re-Exam</span>
                        )}
                      </h5>
                    </div>
                    <div className="card-body Card_design_1">
                      <p>
                        <strong>Class:</strong> <span>{ClassLabel}</span>
                      </p>
                      <p>
                        <strong>Subject:</strong>{" "}
                        <span>
                          {exam?.examdetails?.exam_name?.subject?.name}
                        </span>
                      </p>
                      <p>
                        <strong>Exam Date:</strong>{" "}
                        <span>
                          {exam?.examdetails?.exam_date
                            ? new Date(exam?.examdetails?.exam_date)
                                .toISOString()
                                .split("T")[0]
                            : "N/A"}
                        </span>
                      </p>
                      <p>
                        <strong>Start Time:</strong>{" "}
                        <span>{exam?.examdetails?.start_time}</span>
                      </p>
                      <p>
                        <strong>End Time:</strong>
                        <span>{exam?.examdetails?.end_time}</span>
                      </p>
                      {Automationdata?.data?.[0]?.show_entrance_result ===
                        true && (
                        <>
                          <p>
                            <strong>Marks:</strong>
                            <span>
                              {exam?.mark} /{" "}
                              {exam?.examdetails?.exam_name?.max_marks}
                            </span>
                          </p>
                        </>
                      )}
                      {/* <p>
                      <strong>Status:</strong>{" "}
                      <span style={{ color: getStatusColor(exam?.result) }}>
                        {capitalizeFirstLetter(exam?.result)}
                      </span>
                    </p> */}

                      {/* ✅ Re-Exam Booking */}
                      {/* {getRegistration?.data?.exam_status === "reexam" && ( */}
                      {/* {getRegistration?.data?.exam_status === "reexamed" && (
                    <>
                    {exam?.booking?.status === "reexamed" && (
                      <button
                        className="btn btn-outline-danger mt-2"
                        onClick={() =>
                          navigate("/examretest", {
                            state: {
                              examId: exam?.examdetails?.exam_id,
                              bookingId: exam?.booking?.id,
                            },
                          })
                        }
                      >
                        Book Re-Exam
                      </button>
                    )}
                    </>
                    )} */}

                      {exam?.booking?.status === "reexamed" ? (
                        <button
                          className="btn btn-outline-danger mt-2"
                          onClick={() =>
                            navigate("/examretest", {
                              state: {
                                examId: exam?.examdetails?.exam_id,
                                bookingId: exam?.booking?.id,
                              },
                            })
                          }
                        >
                          Book Re-Exam
                        </button>
                      ) : null}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center mt-5">
            <ImageWithBasePath
              src="assets/img/nodata.gif"
              alt="No data"
              width={200}
            />
            <p className="text-muted mt-3">No Exam Data Found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Entranceresult;
